// @flow
export const SUN = 'SUN';
export const MON = 'MON';
export const TUE = 'TUE';
export const WED = 'WED';
export const THU = 'THU';
export const FRI = 'FRI';
export const SAT = 'SAT';

export const listDays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];



// WEBPACK FOOTER //
// ./src/core/constants/days.js